import React from 'react';
import {SunIcon} from '@heroicons/react/24/outline';
import {usePersistentStore} from 'stores';

interface IButtonThemeProps {}

const ButtonTheme = ({}: IButtonThemeProps) => {
  const toggleTheme = usePersistentStore(s => s.toggleTheme);
  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="cursor-pointer p-2 border border-slate-300 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-700 active:scale-90 rounded-md">
      <SunIcon className="size-5 text-slate-600 dark:text-darkText" />
    </button>
  );
};

export default React.memo(ButtonTheme);
